<template>
  <div class="mb-6 bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-2xl border border-white border-opacity-20 shadow-xl transform transition-all duration-300 hover:bg-opacity-15">
    <h2 class="text-2xl font-bold mb-4 text-white flex items-center">
      <span class="bg-gradient-to-r from-yellow-300 to-yellow-400 w-1.5 h-6 rounded-full mr-3"></span>
      {{title}}
    </h2>
    <p class="text-white text-opacity-90 leading-relaxed text-lg">{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    content: { type: String, required: true }
  }
}
</script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>